import { render } from "./Shipment.vue?vue&type=template&id=03c51844"
import script from "./Shipment.vue?vue&type=script&lang=js"
export * from "./Shipment.vue?vue&type=script&lang=js"

import "./Shipment.vue?vue&type=style&index=0&id=03c51844&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__